export default "__VITE_ASSET__BMPqqpId__"